var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-carousel-container"
  }, [_c('b-carousel', {
    attrs: {
      "id": "carousel-1",
      "interval": 8000,
      "controls": "",
      "indicators": "",
      "img-width": "1024",
      "img-height": "480"
    },
    on: {
      "sliding-start": _vm.onSlideStart,
      "sliding-end": _vm.onSlideEnd
    },
    model: {
      value: _vm.slide,
      callback: function ($$v) {
        _vm.slide = $$v;
      },
      expression: "slide"
    }
  }, [_c('b-carousel-slide', {
    scopedSlots: _vm._u([{
      key: "img",
      fn: function () {
        return [_c('div', {
          staticClass: "rep-dash-bg"
        }, [_c('div', {
          staticClass: "mb-2"
        }, [_c('img', {
          attrs: {
            "src": require("../../assets/images/member-reg.svg"),
            "alt": "Member Dashboard"
          }
        })]), _c('h5', [_vm._v("Member Dashboard")]), _c('p', {
          staticClass: "rep-txt"
        }, [_vm._v(" Experience the ease of access in one place, join our platform for real-time insights and simplified operations. ")])])];
      },
      proxy: true
    }])
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }